import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import SurveyStepFormLayoutPicker from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFormLayoutPicker';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';

import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';

import SurveyStepContextDataDisplay from './SurveyStepContextDataDisplay';

const styles = () => ({
  root: {},
});

const SurveyStepContent = ({
  className,
  classes,
}) => {
  const { onboardingStepResource } = useSurveyContext();
  useScrollTopOnMount();

  return (
    <Box
      className={classNames(classes.root, className)}
      test={`onboarding-survey-step-${onboardingStepResource?.type()}`}
    >
      <SurveyStepContextDataDisplay />
      <SurveyStepFormLayoutPicker
        onboardingStepResource={onboardingStepResource}
      />
    </Box>
  );
};

SurveyStepContent.defaultProps = {
  className: '',
};

SurveyStepContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyStepContent);
